var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-page-banner"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"edit-button",attrs:{"role":"button"}},[_c('i',{staticClass:"fas fa-pencil-alt edit-button-icon"})])])])
}]

export { render, staticRenderFns }